module.exports = __webpack_public_path__ + "0a132510176e6d77264a4172fb3303ac.svg";